import { useContext, useEffect, useState } from 'react'
import { useGetClientTrustBalanceLazyQuery, useGetPublicClientTrustBalanceLazyQuery } from '../../generated'
import { UseGetClientTrustBalanceResult } from '../interfaceTypes'
import { AuthContext } from '../context/AuthContext'
import { GRAPHQL_QUERY_POLICY } from '../constants'

interface UseGetClientTrustBalance {
  caseId?: string
  clientId?: string
  showTrustBalance: boolean
  token?: string
}

const useGetClientTrustBalance = ({
  caseId,
  clientId,
  showTrustBalance,
  token
}: UseGetClientTrustBalance): UseGetClientTrustBalanceResult => {
  const [trustBalance, setTrustBalance] = useState<number>(0)
  const { currentUser } = useContext(AuthContext)

  const [getClientTrustBalance, { loading: isLoadingTrustBalance, error: clientTrustBalanceError }] =
    useGetClientTrustBalanceLazyQuery({
      ...GRAPHQL_QUERY_POLICY,
      variables: undefined,
      onCompleted: data => {
        if (data.getClientTrustBalance?.trustBalance) {
          setTrustBalance(data.getClientTrustBalance.trustBalance)
        }
      }
    })

  const [getPublicClientTrustBalance, { loading: isLoadingPublicTrustBalance, error: publicClientTrustBalanceError }] =
    useGetPublicClientTrustBalanceLazyQuery({
      ...GRAPHQL_QUERY_POLICY,
      variables: undefined,
      onCompleted: data => {
        if (data.getPublicClientTrustBalance?.trustBalance) {
          setTrustBalance(data.getPublicClientTrustBalance.trustBalance)
        }
      }
    })

  useEffect(() => {
    if (showTrustBalance && caseId && clientId) {
      if (currentUser?.id) {
        getClientTrustBalance({
          variables: {
            getClientTrustBalanceInput: { clientId, caseId }
          }
        })
      } else {
        getPublicClientTrustBalance({
          variables: {
            getClientTrustBalanceInput: { clientId, caseId, token }
          }
        })
      }
    }
  }, [caseId, showTrustBalance, clientId, getClientTrustBalance, getPublicClientTrustBalance, token, currentUser?.id])

  return {
    trustBalance,
    loading: isLoadingTrustBalance || isLoadingPublicTrustBalance,
    error: clientTrustBalanceError || publicClientTrustBalanceError
  }
}

export default useGetClientTrustBalance
